module.exports = __webpack_public_path__ + "static/media/anzuum.e49faca6.jpg";